module.exports = "/_next/static/videos/golf-4-107ca39f34b3ae862d1b2727d4353fad.webm";